import { Capacitor } from '@capacitor/core';
import { TextToSpeech } from '@capacitor-community/text-to-speech';
import { LangManager } from './language';

function speechLang () {
    const code = LangManager.getLang();
    if (code === 'en') {
        return 'en-US';
    }
    return 'es-ES';
}

function isWebSpeechAvailable () {
    return typeof window !== 'undefined' && 'speechSynthesis' in window && 'SpeechSynthesisUtterance' in window;
}

export function isTextToSpeechAvailable () {
    if (Capacitor.isNativePlatform()) {
        return true;
    }
    return isWebSpeechAvailable();
}

export async function stopSpeaking () {
    if (Capacitor.isNativePlatform()) {
        try {
            await TextToSpeech.stop();
        } catch (e) {
            console.warn('TextToSpeech.stop failed', e);
        }
    }
    if (isWebSpeechAvailable()) {
        window.speechSynthesis.cancel();
    }
}

function speakWithWebSpeech (text) {
    return new Promise((resolve) => {
        const utterance = new SpeechSynthesisUtterance(text);
        utterance.lang = speechLang();
        utterance.onend = () => resolve();
        utterance.onerror = () => resolve();
        window.speechSynthesis.speak(utterance);
    });
}

/**
 * @param {string} text
 * @returns {Promise<void>}
 */
export async function speakText (text) {
    const trimmed = (text || '').trim();
    if (!trimmed) {
        return;
    }

    if (Capacitor.isNativePlatform()) {
        try {
            await TextToSpeech.speak({
                text: trimmed,
                lang: speechLang(),
                rate: 1.0,
                pitch: 1.0,
                volume: 1.0,
                category: 'playback'
            });
            return;
        } catch (e) {
            console.warn('Native TTS failed, trying Web Speech', e);
        }
    }

    if (isWebSpeechAvailable()) {
        await speakWithWebSpeech(trimmed);
    }
}



// WEBPACK FOOTER //
// ./src/services/TextToSpeech.js